
import { mapConfig } from '@/webtrekk_tracking/config'
import { MediaQuery } from 'foundation-sites/js/foundation.util.mediaQuery'
import mergeDeep from 'lodash-es/merge'
import cloneDeep from 'lodash-es/cloneDeep'

const ACADEMICS_DOMAIN = 'academics'

const MAILTO_PREFIX = 'mailto:'

export default class WebtrekkTracking {
  constructor (config) {
    this.config = config
    this.initialPixelsConfig = null
    this.wts = []
    this.addEventListeners()
  }

  addEventListeners () {
    EventBus.on('tracking:pageload', this.onResults.bind(this))
    EventBus.on('tracking:registrationSuccess', this.onResults.bind(this))
    EventBus.on('tracking:manualEventTrack', this.manualEventTrack.bind(this))
    EventBus.on('tracking:vueEventTrack', this.vueEventTrack.bind(this))
    $(document).on('click', 'a [data-ac-click],a[data-ac-click],button[data-ac-click],label[data-ac-click],input[data-ac-click]', this.onClickTrack.bind(this))
    $(document).on('click', 'a[data-klickout]', this.onJobwareClickTrack.bind(this))
  }

  onResults (_event, webtrekk) {
    this.track(webtrekk)
  }

  onClickTrack (event) {
    if (!event.originalEvent || !event.originalEvent.tracked) {
      if (event.originalEvent) {
        event.originalEvent.tracked = true
      }

      const $target = $(event.currentTarget)
      const params = $.extend(this.trackingContext($target), $target.data('ac-click'))
      // google maps toggle map is handled by a checkbox
      if ($target.attr('type') === 'checkbox') {
        params[9] = $target.is(':checked') ? `${params[9]}_on` : `${params[9]}_off`
      }
      this.trackClick($target, params)
    }
  }

  manualEventTrack (_event, { $elem, action_type: actionType, context }) {
    let params
    if (context) {
      params = { ...mapConfig(context), 9: actionType }
    } else {
      params = { 9: actionType }
    }
    this.trackClick($elem, $.extend(this.trackingContext($elem), params))
  }

  vueEventTrack (event, { el, config }) {
    const $elem = $(el)
    const params = $.extend(this.trackingContext($elem), config)
    this.trackClick($elem, params)
  }

  trackingContext ($element) {
    // addBack() replaces deprecated andSelf()
    // both reverse the order from outer element to inner element
    // since we want inner context to "win" we have to merge onto the accumulator in reduce()
    return $element.parents('[data-ac-context]').addBack()
      .map(function () { return $(this).data('ac-context') || {} })
      .toArray()
      .reduce((acc, obj) => $.extend(acc, obj), {})
  }

  closestContext ($element) {
    return $element.parent().closest('[data-ac-context]')
  }

  onJobwareClickTrack (event) {
    const $target = $(event.currentTarget)
    const params = $.extend(this.trackingContext($target), { 9: $target.data('klickout') })

    this.trackClick($target, params)
  }

  trackClick ($target, params) {
    // Set breakpoint parameter ck4
    params[4] = MediaQuery.current

    if (params.cep) {
      params[6] = `${params[6]}|${params.cep}`
    }

    this.wts.filter(wt => wt.pixelDomain === ACADEMICS_DOMAIN).forEach(wt => {
      const linkId = this.filterUserData($target.attr('href') || params.ct || '#')
      const target = $target.attr('target') || ''
      wt.sendinfo({
        linkId: linkId,
        customClickParameter: params,
        sendOnUnload: target === '_blank' ? 0 : 1
      })
    })
  }

  filterUserData (linkId) {
    return linkId.indexOf(MAILTO_PREFIX) === 0 ? 'mailto' : linkId
  }

  init (initialPixelsConfig) {
    this.initialPixelsConfig = initialPixelsConfig

    this.wts = this.createPixels(this.initialPixelsConfig)
    this.wts.forEach(wt => wt.sendinfo())
  }

  createPixels (pixelsConfig) {
    if (!pixelsConfig) { return }

    const wts = []
    let wt

    Object.keys(pixelsConfig).forEach((domain) => {
      try {
        // eslint-disable-next-line
        wt = new webtrekkV3(this.config)
        Object.keys(pixelsConfig[domain]).forEach((key) => {
          wt[key] = pixelsConfig[domain][key]
        })

        wt.customParameter[12] = this.pageLayout()
        if (domain === ACADEMICS_DOMAIN) {
          wt.customParameter[20] = this.pageOrientation()
        }
        wt.pixelDomain = domain
        wts.push(wt)
      } catch (e) {
        // TODO; gather metrics for failed attempts to create webtrekk pixel
      }
    })

    return wts
  }

  track (pixelsConfig) {
    const mergedConfig = mergeDeep(cloneDeep(this.initialPixelsConfig), pixelsConfig)
    this.createPixels(mergedConfig).forEach(wt => wt.sendinfo())
  }

  pageOrientation () {
    if (window.innerHeight > window.innerWidth) {
      return 'portrait'
    } else {
      return 'landscape'
    }
  }

  pageLayout () {
    if (MediaQuery.current === 'small') {
      return 'mobile.site'
    } else {
      return 'desktop.site'
    }
  }
}

export const bind = () => {
  const pageconfig = {
    linkTrack: 'standard',
    linkTrackAttribute: 'data-wt-click'
  }

  MediaQuery._init()

  return new WebtrekkTracking(pageconfig)
}

global.WebtrekkTracking = bind()
